var storefrontApp = angular.module("storefrontApp");
//#region Home Service
storefrontApp.service('sewingService', ['$http', function ($http) {
    return {
        getProjectsByDefinitions: function (prdDefinition, count) {
            return $http.get('storefrontapi/learningcenter/getprojectsbydefinition?prdDefinition=' + prdDefinition + '&count=' + count);
        },
        getSewingPageContent: function(){
            return $http.get('sewingpagecontent');
        }
    }
}]);
